/* eslint-disable no-param-reassign */

import Vue from 'vue';
import Vuex from 'vuex';

import navigation from './navigation';
import notifications from './notifications';
import uploads from './uploads';
import user from './user';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        navigation,
        notifications,
        uploads,
        user,
    },
});

export default store;
